export default __webpack_public_path__ + "核酸检测.jpeg";